import { faUserFriends } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState } from 'react';
import { User } from '../../Types/User';
import {
  Feature,
  getFeatureIntroducedToUserAt,
  recordFeatureIntroducedToUserAt,
} from '../../Utils/FeatureUsage';
import CoAuthorSelectionModal from './CoAuthorSelectionModal';
import CollaborationIntroModal from './CollaborationIntroModal';

interface CoAuthorSelectionButtonProps {
  selectedCoAuthor: User | null;
  onSelectCoAuthor: (coAuthor: User) => void;
}

const CoAuthorSelectionButton: React.FC<CoAuthorSelectionButtonProps> = ({
  selectedCoAuthor,
  onSelectCoAuthor,
}) => {
  const [showCoAuthorSelectionModal, setShowCoAuthorSelectionModal] =
    useState(false);
  const [showCollaborationIntro, setShowCollaborationIntro] = useState(false);

  const openCoAuthorSelectionFlow = () => {
    if (!getFeatureIntroducedToUserAt(Feature.BOOK_COLLABORATION)) {
      // User hasn't seen the intro yet or hasn't checked "Don't show this again"
      setShowCollaborationIntro(true);
    } else {
      // User has already chosen not to see the intro again
      setShowCoAuthorSelectionModal(true);
    }
  };

  const closeCollaborationIntro = () => {
    setShowCollaborationIntro(false);
  };

  const continueToCoAuthorSelection = (dontShowAgain: boolean) => {
    if (dontShowAgain) {
      recordFeatureIntroducedToUserAt(Feature.BOOK_COLLABORATION, new Date());
    }
    setShowCollaborationIntro(false);
    setShowCoAuthorSelectionModal(true);
  };

  const closeCoAuthorSelectionModal = () => {
    setShowCoAuthorSelectionModal(false);
  };

  const handleCoAuthorSelected = (coAuthor: User | null) => {
    if (coAuthor) {
      onSelectCoAuthor(coAuthor);
    }
    closeCoAuthorSelectionModal();
  };

  const onShowIntro = () => {
    setShowCollaborationIntro(true);
  };

  return (
    <>
      <button
        onClick={openCoAuthorSelectionFlow}
        className="flex items-center gap-2 px-2 py-1 text-sm font-medium text-blue-600 bg-white border border-blue-600 rounded-full hover:bg-blue-50"
      >
        <FontAwesomeIcon icon={faUserFriends} className="w-4 h-4" />
        <span className="md:inline hidden">Create with a Friend</span>
      </button>

      {/* Collaboration Intro Modal */}
      <CollaborationIntroModal
        isOpen={showCollaborationIntro}
        onClose={closeCollaborationIntro}
        onContinue={continueToCoAuthorSelection}
      />

      {/* Co-Author Selection Modal */}
      <CoAuthorSelectionModal
        isOpen={showCoAuthorSelectionModal && !showCollaborationIntro}
        onClose={closeCoAuthorSelectionModal}
        onSelectCoAuthor={handleCoAuthorSelected}
        initialSelectedCoAuthor={selectedCoAuthor}
        onShowIntro={onShowIntro}
      />
    </>
  );
};

export default CoAuthorSelectionButton;
